import React, { useEffect, useState } from "react";
import { Select } from "chakra-react-select";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Spinner,
  useToast,
} from "@chakra-ui/react";

import { GetSuppliers } from "services/SuppliersService";

import {
  PatchUserAssociatedSupplierForAdmin,
  GetUserAssociatedSupplierForAdmin,
} from "services/SuppliersService";

import check_icon from "assets/images/icons/check_icon.png";

export default function AssociateNewSupplierModal(props) {
  const { isOpen, onClose, user_id, updateTable } = props;

  const [availableSuppliers, setAvalableSuppliers] = useState([]);
  const [errorText, setErrorText] = useState("");
  const [selectSupplier, setSelectSupplier] = useState([]);

  const [loading, setLoading] = useState(false);

  const toast = useToast();

  useEffect(() => {
    const fetch_suppliers = async () => {
      try {
        const response = await GetSuppliers();
        const supplier_data = response.data.data;
        const selectSupplierList = supplier_data.map((supplier) => {
          return {
            value: supplier.supplier_id,
            label: supplier.supplier_name,
            class: supplier.supplier_class,
          };
        });

        setAvalableSuppliers(selectSupplierList);
      } catch (error) {
        console.log(error, " error");
      }
    };

    const fetch_associated_suppliers = async () => {
      try {
        const params = {
          page_size: 10,
          page_number: -1,
          user_id: user_id,
        };

        const response_suppliers_data = await GetUserAssociatedSupplierForAdmin(
          params
        );

        const selectValueTemp = response_suppliers_data?.data.data.map(
          (supplier) => {
            return {
              value: supplier.supplier.supplier_id,
              label: supplier.supplier.supplier_name,
              class: supplier.supplier.supplier_class,
            };
          }
        );

        setSelectSupplier(selectValueTemp);
      } catch (error) {
        console.log(error, " error");
      }
    };

    const fetch_all_data = async () => {
      try {
        setLoading(true);
        await Promise.all([fetch_suppliers(), fetch_associated_suppliers()]);
        setLoading(false);
      } catch (error) {
        console.log(error, " error");
        setLoading(false);
      }
    };

    fetch_all_data();
  }, []);

  const handleAssociateSupplier = async (e) => {
    e.preventDefault();

    setLoading(true);

    const supplier_ids = selectSupplier.map((supplier) => supplier.value);

    const params = {
      user_id: user_id,
      supplier_list: supplier_ids,
    };

    try {
      const res = await PatchUserAssociatedSupplierForAdmin(params);
      toast({
        title: "Supplier Associated",
        description: "Supplier has been associated with user",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onClose && onClose();
      updateTable && updateTable();
    } catch (error) {
      console.log(error, " error");
      setErrorText("An Error Occured. Please try again");

      toast({
        title: "Error",
        description: "An Error Occured. Please try again",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <div className="flex flex-row gap-2">
            {/* <div className="h-6 w-6  flex flex-col justify-center ">
              <img src={edit_icon_dark} />
            </div> */}

            <h4>Associate New Supplier with </h4>
          </div>

          <ModalCloseButton />
        </ModalHeader>

        <ModalBody sx={{ padding: "2rem" }}>
          <div className="flex flex-col gap-5">
            <div>
              <p className="label">Select Supplier</p>
              <Select
                isMulti
                isInvalid={errorText}
                variant="outlineSelect"
                options={availableSuppliers}
                value={selectSupplier}
                onChange={setSelectSupplier}
              />
            </div>
            <div>
              <div className="w-52">
                <Button
                  type="submit"
                  variant="solid"
                  isDisabled={loading}
                  onClick={handleAssociateSupplier}
                >
                  {loading ? (
                    <Spinner />
                  ) : (
                    <>
                      <img className="mr-2" src={check_icon} />
                      Associate Supplier
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
